import { SvgIcon } from '../SvgIcon';
import * as React from 'react';

export const CampaignIconDefaultWidth = 197;

interface IProps {
	className?: string;
}

export const CampaignIcon: React.FC<IProps> = props => {
	const { className } = props;
	return (
		<SvgIcon className={`campaign-icon ${className || ''}`} height={123} width={CampaignIconDefaultWidth}>
			<svg width='197' height='123' viewBox='0 0 197 123' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<rect x='46' y='14' width='21' height='8' rx='2' fill='#D6F4FD' />
				<rect x='131' y='114' width='38' height='8' rx='2' fill='#DBF2C3' />
				<rect x='156' y='88' width='29' height='8' rx='2' fill='#D6F4FD' />
				<rect width='30' height='7' rx='2' transform='matrix(1 0 0 -1 5 100)' fill='#DBF2C3' />
				<rect width='25' height='7' rx='2' transform='matrix(1 0 0 -1 19 116)' fill='#D6F4FD' />
				<rect x='126' y='76' width='29' height='8' rx='2' fill='#DBF2C3' />
				<rect y='11' width='25' height='8' rx='2' fill='#DBF2C3' />
				<rect x='23' y='62' width='38' height='8' rx='2' fill='#D6F4FD' />
				<rect x='49' y='47' width='29' height='8' rx='2' fill='#D6F4FD' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M99.8317 64.6471H195.376V11.4465H99.8317V64.6471Z'
					fill='#FEFEFE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M99.8317 64.6471H195.376V11.4465H99.8317V64.6471Z'
					stroke='#27A9E0'
					strokeWidth='2.266'
				/>
				<mask id='mask0' type='alpha' maskUnits='userSpaceOnUse' x='98' y='11' width='98' height='39'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M98.9862 11.9699L136.144 45.9162C136.144 45.9162 143.96 52.7068 152.185 46.4743L195.376 11.9699H98.9862Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask0)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M100.739 11.9699L137.221 45.9162C137.221 45.9162 144.895 52.7068 152.97 46.4743L195.376 11.9699H100.739Z'
						fill='url(#paint0_linear)'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M100.677 64.3035L147.034 29.4179L195.376 64.3035H100.677Z'
					stroke='#27A9E0'
					strokeWidth='2.268'
					strokeLinejoin='bevel'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M154.756 43.3585L195.376 11.975H100.677L139.043 42.801C139.043 42.801 146.699 49.5854 154.756 43.3585Z'
					fill='#FEFEFE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M154.756 43.3585L195.376 11.975H100.677L139.043 42.801C139.043 42.801 146.699 49.5854 154.756 43.3585Z'
					stroke='#27A9E0'
					strokeWidth='2.268'
					strokeLinejoin='bevel'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M33.881 29.1801H82.0757V1.31308H33.881V29.1801Z'
					fill='#FEFEFE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M33.881 29.1801H82.0757V1.31308H33.881V29.1801Z'
					stroke='#27A9E0'
					strokeWidth='1.193'
				/>
				<mask id='mask1' type='alpha' maskUnits='userSpaceOnUse' x='33' y='1' width='50' height='20'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M33.0355 1.31308L51.9405 19.0668C51.9405 19.0668 55.9166 22.6184 60.1016 19.3588L82.0757 1.31308H33.0355Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M33.0355 1.31308L51.9405 19.0668C51.9405 19.0668 55.9166 22.6184 60.1016 19.3588L82.0757 1.31308H33.0355Z'
						fill='url(#paint1_linear)'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M33.881 29.18L57.4733 11.4465L82.0757 29.18H33.881Z'
					stroke='#27A9E0'
					strokeWidth='1.194'
					strokeLinejoin='bevel'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M60.5576 17.6755L81.2302 1.31308H33.0355L52.5608 17.3846C52.5608 17.3846 56.4572 20.9219 60.5576 17.6755Z'
					fill='#FEFEFE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M61.4031 17.6755L82.0757 1.31308H33.881L53.4063 17.3846C53.4063 17.3846 57.3028 20.9219 61.4031 17.6755Z'
					stroke='#27A9E0'
					strokeWidth='1.194'
					strokeLinejoin='bevel'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M53.328 121.226H118.433V84.0695H53.328V121.226Z'
					fill='#FEFEFE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M53.328 121.226H118.433V84.0695H53.328V121.226Z'
					stroke='#27A9E0'
					strokeWidth='1.585'
				/>
				<mask id='mask2' type='alpha' maskUnits='userSpaceOnUse' x='53' y='84' width='66' height='27'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M53.328 84.914L78.4258 108.071C78.4258 108.071 83.7047 112.703 89.2606 108.452L118.433 84.914H53.328Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask2)'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M53.328 84.914L78.4258 108.071C78.4258 108.071 83.7047 112.703 89.2606 108.452L118.433 84.914H53.328Z'
						fill='url(#paint2_linear)'
					/>
				</g>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M53.328 121.226L85.1981 96.7364L118.433 121.226H53.328Z'
					stroke='#27A9E0'
					strokeWidth='1.586'
					strokeLinejoin='bevel'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M90.507 105.886L118.433 84.0695H53.328L79.7043 105.498C79.7043 105.498 84.9679 110.215 90.507 105.886Z'
					fill='#FEFEFE'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M90.507 105.886L118.433 84.0695H53.328L79.7043 105.498C79.7043 105.498 84.9679 110.215 90.507 105.886Z'
					stroke='#27A9E0'
					strokeWidth='1.586'
					strokeLinejoin='bevel'
				/>
				<defs>
					<linearGradient
						id='paint0_linear'
						x1='100.739'
						y1='49.1068'
						x2='195.376'
						y2='49.1068'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#FEFEFE' />
						<stop offset='1' stopColor='#DFE0E1' />
					</linearGradient>
					<linearGradient
						id='paint1_linear'
						x1='33.0356'
						y1='20.7353'
						x2='82.0757'
						y2='20.7353'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#FEFEFE' />
						<stop offset='1' stopColor='#DFE0E1' />
					</linearGradient>
					<linearGradient
						id='paint2_linear'
						x1='53.328'
						y1='110.248'
						x2='118.433'
						y2='110.248'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor='#FEFEFE' />
						<stop offset='1' stopColor='#DFE0E1' />
					</linearGradient>
				</defs>
			</svg>
		</SvgIcon>
	);
};
